/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/Axeptio.js
class Axeptio {
  constructor() {
    this.footerLinksSelector = '.footer .footer__link-list a';
  }

  init = () => {
    const footerLinks = document.querySelectorAll(this.footerLinksSelector);

    if (footerLinks.length === 0) {
      return;
    }

    footerLinks.forEach((link) => {
      if (link.href.includes('#replaceAxeptio')) {
        // eslint-disable-next-line no-script-url
        link.href = 'javascript:openAxeptioCookies()';
      }
    });
  };
}

;// ./src/js/SubscriberPrice.js
class SubscriberPrice {
  constructor() {
    this.productSelector = '.main-product__section';
    this.subscriberPriceSelector = '.price__subscriber-price';
    this.subscriberPriceValueSelector = '.price__subscriber-price-value';
    this.discountPercentage = 0.1;
  }

  init = () => {
    const product = document.querySelector(this.productSelector);

    if (!product) {
      return;
    }

    const subscriberPrice = product.querySelector(this.subscriberPriceSelector);
    const subscriberPriceValue = product.querySelector(
      this.subscriberPriceValueSelector
    );

    if (!subscriberPrice || !subscriberPriceValue) {
      return;
    }

    document.addEventListener('variant:change', (e) => {
      const discountedPrice =
        e.detail.variant.price -
        e.detail.variant.price * this.discountPercentage;
      const formattedPrice = (discountedPrice * 0.01)
        .toFixed(2)
        .replace('.', ',');

      subscriberPriceValue.innerText = `${formattedPrice}€`;
    });
  };
}

;// ./src/main.js

// JS goes here



window.addEventListener('load', () => {
  const classes = [new Axeptio(), new SubscriberPrice()];
  classes.forEach((classe) => classe.init());
});

/******/ })()
;